import {
	IndexPage,
	PackagingStrategyListing,
	PackagingStrategyDetails,
	Alerts,
	UserManagementListTable,
	AddUser,
	UpdateUser,
	AddUpdateStrategyForm,
} from 'src/modules';
import Dashboard from 'src/modules/dashboard/Dashboard';
import MisReports from 'src/modules/misReports/MisReports';

export const routes_all = [
	{
		path: '/',
		name: 'IndexPage',
		Component: <IndexPage />,
		module_code: 'index_page',
	},
	{
		path: '/packaging-strategy',
		name: 'Packaging Strategy',
		Component: <PackagingStrategyListing />,
		module_code: 'packaging_strategy',
	},
	{
		path: '/packaging-strategy/add-strategy',
		name: 'AddStrategyForm',
		Component: <AddUpdateStrategyForm />,
		module_code: 'add_packaging_strategy',
	},
	{
		path: '/packaging-strategy/update-strategy',
		name: 'UpdateStrategyForm',
		Component: <AddUpdateStrategyForm />,
		module_code: 'update_packaging_strategy',
	},
	{
		path: '/packaging-strategy/draft-strategy',
		name: 'DraftStrategyForm',
		Component: <AddUpdateStrategyForm />,
		module_code: 'draft_packaging_strategy',
	},
	{
		path: '/packaging-strategy-details',
		name: 'PackagingStrategyDetails',
		Component: <PackagingStrategyDetails />,
		module_code: 'packaging_strategy_details',
	},
	{
		path: '/alerts',
		name: 'Alert',
		Component: <Alerts />,
		module_code: 'alerts',
	},
	{
		path: '/mis-reports',
		name: 'MIS Reports',
		Component: <MisReports />,
		module_code: 'mis_reports',
	},
	{
		path: '/dashboard',
		name: 'Dashboard',
		Component: <Dashboard />,
		module_code: 'dashboard',
	},
	{
		path: '/user-management',
		name: 'UserManagementListTable',
		Component: <UserManagementListTable />,
		module_code: 'user_management',
	},
	{
		path: '/user-management/create-user',
		name: 'AddUserManagement',
		Component: <AddUser />,
		module_code: 'add_user',
	},
	{
		path: '/user-management/update-user',
		name: 'UpdateUserManagement',
		Component: <UpdateUser />,
		module_code: 'update_user',
	}
];

// privilege keys to tool list

export const LANDING_PAGE_MODULE_CODE = {
	dashboard: 'dashboard',
	packaging_strategy_details: 'packaging_strategy_details',
	packaging_strategy: 'packaging_strategy',
	mis_reports: 'mis_reports',
	user_management: 'user_management',
	user_manual: 'user_manual'
	//usage_analytics: 'usage_analytics',
};

// provide user to access routes based on their role(should be added if new routes is added)

export const dateFieldHeader = [
	'updated_at',
	'time',
	'created_at',
	'dmp_buyer_status_evaluated_at',
	'scm_buyer_status_evaluated_at',
	'logistics_buyer_status_evaluated_at',
	'raised_on',
];

export const tooltipFieldHeader = [
	'supplier_name',
	'part_description',
	'dmp_approval_remark',
	'scm_approval_remark',
	'logistics_approval_remark',
	'part_no'
];

export const excludeDownload = [
	'passive_id',
	'id',
	'status',
	'is_deleted',
	'reset_pin',
];
// export const sequenceStatus = ['sequencing_status', 'ihs_completion'];
export const sequenceStatus = ['dmp_approval_status', 'logistics_approval_status', 'scm_approval_status','approval_status'];

export const imageFormat = ['part_image_link'];
export const bulkUploadLimit = 5000;

export const Title = {
	logistics_and_packaging: 'Logistics & Packaging',
	home: 'Home',
	alerts: 'Alerts',
	packaging_strategy_listing: 'Packaging Strategy List',
	packaging_strategy_details: 'Packaging Strategy Details',
	tata_autocomp_systems_ltd_packaging_document: 'TATA MOTORS PACKAGING & TRANSPORTATION COST APPROVAL DOCUMENT',
	packaging_strategy: 'Logistics Planning Strategies',
	usage_analytics: 'Usage Analytics',
	mis_reports: 'MIS Reports',
	dashboard: 'Dashboard',
	user_management: 'User Management',
	user_manual: 'User Manual',
	user: 'User',
	add_user: 'Add User',
	update_user: 'Update User',
	add_strategy: 'Create Logistics Form',
	edit_strategy: 'Edit Strategy',
	edit_draft_strategy: 'Edit Drafted Strategy'
};

export const HelpAndSupportVaribles = {
	tml_spoc_name: 'Vishwanath Rao',
	tml_spoc_email: 'vishwanath.rao@tatamotors.com',
	tml_spoc_contact: '9033091070'
};

export const commonVaribles = {
	workbook_Note: 'Please upload maximum 5 Workbooks per Excel File',
	excel_Note: 'Ensure that the format is .xlsx, .xlsm',
	sample_excel_template_name: 'PV Logistics & Packaging Template',
	sample_excel_template_folder: 'packaging-template',
	sample_excel_template_label: 'Download Logistics & Packaging Template',
	file_download_failed: 'File Download Failed',
	user_manual_folder: 'user-manual',
	user_manual_file_name: 'PV Logistics & Packaging User Manual',
	update_strategy_title: 'UPDATE STRATEGY',
	update: 'UPDATE',
	reupload: 'RE UPLOAD',
	excel_update_note_1: '1. Download this strategy.',
	excel_update_note_2: '2. Update the strategy.',
	excel_update_note_3: '3. Upload the strategy (format is xlsx, xlsm)',
	excel_update_download_strategy: 'DOWNLOAD EXCEL',
	excel_attachment_strategy: 'ATTACHMENT',
	strategy_excel_upload_title: 'UPLOAD EXCEL SHEET',
	// strategy_excel_upload: 'Add Strategy',
	packaging_strategy: 'Packaging Strategies',
	plant_name: 'Plant Name',
	feedback: 'FeedBack',
	reupload: 'Re Upload',
	excelErrormsg: 'Upload Valid Excel Files',
	excelErrorInNumbers: 'Please upload maximum 5 Excel files.',
	excelFilesSizeError: 'File size should not exceed 10 MB.',
	post: 'POST',
	get: 'GET',
	all: 'all',
	non_mapped: 'non-mapped',
	submit: 'SUBMIT',
	submit_anyways: 'SUBMIT ANYWAYS',
	image_submission_confirmation: 'Image Submission Confirmation',
	incomplete: 'incomplete',
	error: 'error',
	success: 'success',
	Download: 'Download',
	download_summary: 'Download Summary',
	Update: 'Update',
	Delete: 'Delete',
	add: 'ADD',
	add_strategy: 'Create Logistics Form',
	bulk_data: 'Bulk Data',
	admin: 'Admin',
	upper_update: 'UPDATE',
	enable: 'Enable',
	disable: 'Disable',
	skip_configuration: 'skip_configuration',
	packaging_strategy_listing: 'packaging_strategy_listing',
	packaging_strategy_details: 'packaging_strategy_details',
	add_packaging_strategy: 'add_packaging_strategy',
	update_packaging_strategy: 'update_packaging_strategy',
	download_packaging_strategy: 'download_packaging_strategy',
	add_approval: 'add_approval',
	delete_packaging_strategy: 'delete_packaging_strategy',
	add_new_reason: 'Add new reason',
	enter: 'Enter',
	enter_the_reason: 'Enter the reason',
	record_already_exists: 'Record already exists',
	alert: 'alert',
	sequencing_report_list: 'Sequencing Report List',
	trolley_master: 'trolley_master',
	trolley_master_list: 'Trolley master List',
	user_management: 'user_management',
	add_user: 'add_user',
	delete_user: 'delete_user',
	update_user: 'update_user',
	user_list: 'User_list',
	warning: 'warning',
	correct: 'correct',
	cross: 'cross',
	alertsResolve_msg: 'Do you want to mark this issue as resolved ?',
	alertsUnresolved_msg: 'Do you want to mark this issue as unresolved ?',
	vc_not_mapped: 'VC not mapped',
	all_alerts: 'All alerts',
	completed: 'Completed',
	in_progress: 'In-progress',
	pending: 'Pending',
	buffer: 'Buffer Count',
	bar: 'bar',
	inside: 'inside',
	vins: 'VINS',
	data_not_found: 'Data Not Found',
	please_use_the_search_box: 'Please use the search box!',
	bulk_data_btn: 'Bulk data',
	report_download_in_progress: 'Sequence Report Downloading in Progress',
	note: '*Note:',
	img_Note1: '1) Enter the part Image Name as "PartNo".',
	img_Note2: '2) Ensure that the image format is JPEG, PNG, and JPG.',
	img_Note3: '3) The maximum number of uploads at a time is 100 images.',
	cancel: 'CANCEL',
	upload: 'Upload',
	imageErrormsg: '*Please select proper image format ( JPEG/JPG or PNG ).',
	logout: 'LOGOUT',
	scatter: 'scatter',
	regenerate_sequence: 'Regenerate Sequence',
	upload_img: 'Upload Image',
	customDeleteMessage:
		'Are you sure you want to delete it? Once deleted it cannot be recovered and dependent data will be removed.',
	bulk_part_image_upload: 'bulk_part_image_upload',
	file_upload_successfully: 'File uploaded successfully',
	failed_to_upload_excel_sheet: 'Failed to Store Excel Sheet, Please Try Again',
	file_upload_failed: 'File upload failed',
	part_image_upload: 'Parts Image Upload',
	no_record_deleted: 'No Records Deleted',
	records_deleted: 'Records Successfully Deleted',
	record_deleted_successfully: 'Record Deleted Successfully',
	records_deleted_successfully: 'Records Deleted Successfully',
	yes: 'Yes',
	no: 'No',
	part_logistics_sheet_Not_received: 'Part logistics sheet not received from P&SQ/Not recommended',

	upload_logistics_sheet: 'Upload Logistics Sheet',
	errorMsgForUserFullName:
		'Invalid Full name. enter in the following format :- Abc123',
	errorMsgForUsername:
		'Invalid Username. enter in the following format :- Test123',
	errorMsgForEmail: `Invalid Last name. enter in the following format :- TataMotors ${new Date().getFullYear()}@.com`,
	errorMsgForVendorCode:
		'Invalid Vendor code. enter in the following format :- T0000',
	errorMsgForMobileNumber:
		'Invalid Mobile No. enter in the following format :- 1111111111',
	errorMsgForCostNo:
		'Invalid Cost Number. Please enter Number in following format: 00 or 00.00',
	errorMsgForBuyerCode:
		'Invalid Buyer Code. Plaease enter Valid Buyer Code.'
};
